<template lang="html">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path :fill="color" d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z M8.209,17.479h-1.37V6.522
        h10.954v1.371H8.209V17.479z M10.947,10.604c0,0.205-0.062,0.4-0.167,0.561l1.104,1.839c0.028-0.002,0.06-0.003,0.089-0.003
        c0.03,0,0.062,0.001,0.09,0.003l1.104-1.839c-0.104-0.16-0.164-0.355-0.164-0.561c0-0.566,0.459-1.027,1.025-1.027
        c0.565,0,1.027,0.461,1.027,1.027c0,0.213-0.066,0.414-0.181,0.578l1.824,3.188c0.021-0.002,0.045-0.002,0.065-0.002
        c0.568,0,1.027,0.459,1.027,1.026c0,0.566-0.459,1.026-1.027,1.026c-0.565,0-1.027-0.46-1.027-1.026
        c0-0.215,0.066-0.414,0.181-0.578l-1.821-3.188c-0.023,0-0.048,0-0.068,0c-0.029,0-0.062,0-0.09-0.002l-1.104,1.839
        c0.104,0.161,0.168,0.354,0.168,0.561c0,0.566-0.463,1.027-1.028,1.027s-1.026-0.461-1.026-1.027c0-0.205,0.061-0.399,0.166-0.561
        l-1.104-1.839C9.98,11.63,9.95,11.63,9.92,11.63c-0.566,0-1.027-0.459-1.027-1.025S9.354,9.577,9.92,9.577
        C10.487,9.577,10.947,10.038,10.947,10.604z"/>
    </svg>
</template>

<script>
import { navIcon } from '@/functions/appColors';

export default {
    props: {
        color: {
            default: String(navIcon),
            type: String,
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/icons/GwLevel.vue